import { UtilityFunctions } from './../../../classes/UtilityFunctions';
import { Component, Input } from '@angular/core';

import { WidgetConfiguration } from '../../../interfaces/WidgetInterfaces';
import { DisplayStateService } from '../../../services/DisplayStateService';

@Component({
  selector: 'app-core-widget-container',
  template: `<div *ngIf="UserAcessDenied(); else OK">
  <h4>Component requires platform administration access.</h4>
</div>

<ng-template #OK>
  <div [ngSwitch]="Config.componentType">

    <div *ngSwitchCase="'MasterConfiguration'">       <app-master-configuration [Config]="Config"></app-master-configuration> </div>
    <div *ngSwitchCase="'app-master-configuration'">  <app-master-configuration [Config]="Config"></app-master-configuration> </div>

    <div *ngSwitchCase="'app-user-widget-prefs'">     <app-user-widget-prefs [Config]="Config"></app-user-widget-prefs>       </div>
    
    <div *ngSwitchCase="'app-landing-page'">          <app-landing-page [Config]="Config"></app-landing-page>   </div>

    <div *ngSwitchCase="'CacheDataAdmin'">            <app-cache-data-admin [Config]="Config"></app-cache-data-admin>         </div>
    <div *ngSwitchCase="'app-cache-data-admin'">      <app-cache-data-admin [Config]="Config"></app-cache-data-admin>         </div>

    <div *ngSwitchCase="'app-data-policy-testing'">   <app-data-policy-testing [Config]="Config"></app-data-policy-testing>   </div>

    <div *ngSwitchCase="'WidgetHelp'">                <app-widget-help [Config]="Config"></app-widget-help>                   </div>
    <div *ngSwitchCase="'app-widget-help'">           <app-widget-help [Config]="Config"></app-widget-help>                   </div>

    <div *ngSwitchCase="'Diagnostics'">               <app-diagnostics [Config]="Config"></app-diagnostics>                   </div>
    <div *ngSwitchCase="'app-diagnostics'">           <app-diagnostics [Config]="Config"></app-diagnostics>                   </div>

    <div *ngSwitchCase="'RandomChartWidget'">         <app-random-chart [Config]="Config"></app-random-chart>                 </div>
    <div *ngSwitchCase="'app-random-chart'">          <app-random-chart [Config]="Config"></app-random-chart>                 </div>

    <div *ngSwitchCase="'GenericWidgetChart'">        <app-generic-chart [Config]="Config"></app-generic-chart>               </div>
    <div *ngSwitchCase="'app-generic-chart'">         <app-generic-chart [Config]="Config"></app-generic-chart>               </div>

    <div *ngSwitchCase="'GenericWidgetTable'">        <app-generic-table [Config]="Config"></app-generic-table>               </div>
    <div *ngSwitchCase="'app-generic-table'">         <app-generic-table [Config]="Config"></app-generic-table>               </div>

    <div *ngSwitchCase="'TableauComponent'">          <app-tableau [Config]="Config"></app-tableau>                           </div>
    <div *ngSwitchCase="'app-tableau'">               <app-tableau [Config]="Config"></app-tableau>                           </div>

    <div *ngSwitchCase="'GenericGroupedDataSideNav'"> <app-generic-side-nav [Config]="Config"></app-generic-side-nav>         </div>
    <div *ngSwitchCase="'app-generic-side-nav'">      <app-generic-side-nav [Config]="Config"></app-generic-side-nav>         </div>

    <div *ngSwitchDefault>
      <h3>No component registered for configuration name '{{Config.componentType}}'</h3>
    </div>
  </div>
</ng-template>
`,
  styles: [`span{
    width:auto;
    height:auto;
    display:inline-block;
}

`]
})
export class CoreWidgetContainerComponent {

  @Input() Config: WidgetConfiguration;
  flag = false;
  constructor(private displayStateService: DisplayStateService) {}

  UserAcessDenied() {
    if (!this.Config.adminRequired) {
      return false;
    } else {
      return !this.displayStateService.appState.current.userIsAdmin;
    }
  }  
}
